module.exports = __webpack_public_path__ + "static/media/05.c855ade3.mp3";